
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/rental-yield-calculator",
      function () {
        return require("private-next-pages/calculators/rental-yield-calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/rental-yield-calculator"])
      });
    }
  